import React from 'react';
import { makeStyles, Grid, Typography } from '@material-ui/core';
import DrangAndDrop from '../../UploadForm/DragAndDrop';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  input: {
    width: '100%'
  },
  disabled: {
    width: '100%',
    color: 'rgba(0, 0, 0, 0.38)'
  },
  form: {
    marginBottom: 0
  },
  formControl: {
    width: '100%',
    marginTop: 16
  },
  button: {
    marginTop: 16
  },
  typography: {
    width: '100%'
  }
}));

const UploadFile = (props) => {
  const { uiSchema } = props;
  const { accept, multiple } = uiSchema['ui:options'];
  const classes = useStyles();
  const { t } = useTranslation();

  const onUploadedFiles = (files) => {
    props.onChange(files);
  };

  return (
    <Grid container>
      <Typography component='label' className={classes.typography}>
        {t('certificate:createForm:files')}
        <DrangAndDrop
          setContent={onUploadedFiles}
          accept={accept}
          multiple={multiple}
          returnFormat='base64'
        />
      </Typography>
    </Grid>
  );
};

export default UploadFile;
